// Translation: Model > Phone number verifier > Phone verification dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		resend: 'Tekrar gönder',
		send: 'Gönder'
	},
	input: {
		placeholder: 'Kodu girin'
	},
	title: 'Telefon numaranızı doğrulayın'
})
